/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.TextelBlast {
    angular.module("meevo.plugins.textelBlast", []);
}
